<template>
	<div class="im-wrap-site">
		<img :src="require(`@/assets/Logo.png`)" alt="Logo of the bwHealthApp" @click="toHome" />
		<h1 v-html="translations.imTitle"></h1>
		<div class="im-wrap-content">
			<div>
				<h2 v-html="translations.imProviderTitle"></h2>
				<p v-html="translations.imProviderText1"></p>
				<p v-html="translations.imProviderText2"></p>
				<p v-html="translations.imProviderText3"></p>
				<p v-html="translations.imProviderText4"></p>
				<p v-html="translations.imProviderText5"></p>
				<p v-html="translations.imProviderText6"></p>
				<h2 v-html="translations.imContentTitle"></h2>
				<p v-html="translations.imContentText1"></p>
				<p v-html="translations.imContentText2"></p>
				<p v-html="translations.imContentText3"></p>

				<h2 v-html="translations.imSupervisoryAuthorityTitle"></h2>
				<p v-html="translations.imSupervisoryAuthorityText1"></p>
				<p v-html="translations.imSupervisoryAuthorityText2"></p>
				<h2 v-html="translations.imSupervisoryAuthorityDataTitle"></h2>
				<p v-html="translations.imSupervisoryAuthorityDataText1"></p>
				<p v-html="translations.imSupervisoryAuthorityDataText2"></p>
				<h2 v-html="translations.imDisputeResolutionTitle"></h2>
				<p v-html="translations.imDisputeResolutionText1"></p>
				<p v-html="translations.imDisputeResolutionText2"></p>
				<p v-html="translations.imDisputeResolutionText3"></p>
				<h2 v-html="translations.imDataProtectionOfficerTitle"></h2>
				<p v-html="translations.imDataProtectionOfficerText1"></p>
				<p v-html="translations.imDataProtectionOfficerText2"></p>
				<p v-html="translations.imDataProtectionOfficerText3"></p>
				<h2 v-html="translations.imTechnicalSupportTitle"></h2>
				<p v-html="translations.imTechnicalSupportText1"></p>
				<p v-html="translations.imTechnicalSupportText2"></p>
				<h2 v-html="translations.imDisclaimerTitle"></h2>
				<h3 v-html="translations.imDisclaimerContentTitle"></h3>
				<p v-html="translations.imDisclaimerContentText1"></p>
				<h3 v-html="translations.imDisclaimerLinksTitle"></h3>
				<p v-html="translations.imDisclaimerLinksText1"></p>
				<h3 v-html="translations.imDisclaimerCopyrightTitle"></h3>
				<p v-html="translations.imDisclaimerCopyrightText1"></p>
				<h2 v-html="translations.imDisclaimerMediaTitle"></h2>
				<p v-html="translations.imDisclaimerMediaText"></p>
			</div>
		</div>
	</div>
</template>

<script>
import i18n from '@/translations/i18n';
export default {
	name: 'Impressum',
	data() {
		return {
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				imTitle: this.$t('imTitle'),
				imProviderTitle: this.$t('imProviderTitle'),
				imProviderText1: this.$t('imProviderText1'),
				imProviderText2: this.$t('imProviderText2'),
				imProviderText3: this.$t('imProviderText3'),
				imProviderText4: this.$t('imProviderText4'),
				imProviderText5: this.$t('imProviderText5'),
				imProviderText6: this.$t('imProviderText6'),
				imContentTitle: this.$t('imContentTitle'),
				imContentText1: this.$t('imContentText1'),
				imContentText2: this.$t('imContentText2'),
				imContentText3: this.$t('imContentText3'),
				imSupervisoryAuthorityTitle: this.$t('imSupervisoryAuthorityTitle'),
				imSupervisoryAuthorityText1: this.$t('imSupervisoryAuthorityText1'),
				imSupervisoryAuthorityText2: this.$t('imSupervisoryAuthorityText2'),
				imSupervisoryAuthorityDataTitle: this.$t('imSupervisoryAuthorityDataTitle'),
				imSupervisoryAuthorityDataText1: this.$t('imSupervisoryAuthorityDataText1'),
				imSupervisoryAuthorityDataText2: this.$t('imSupervisoryAuthorityDataText2'),
				imDisputeResolutionTitle: this.$t('imDisputeResolutionTitle'),
				imDisputeResolutionText1: this.$t('imDisputeResolutionText1'),
				imDisputeResolutionText2: this.$t('imDisputeResolutionText2'),
				imDisputeResolutionText3: this.$t('imDisputeResolutionText3'),
				imDataProtectionOfficerTitle: this.$t('imDataProtectionOfficerTitle'),
				imDataProtectionOfficerText1: this.$t('imDataProtectionOfficerText1'),
				imDataProtectionOfficerText2: this.$t('imDataProtectionOfficerText2'),
				imDataProtectionOfficerText3: this.$t('imDataProtectionOfficerText3'),
				imTechnicalSupportTitle: this.$t('imTechnicalSupportTitle'),
				imTechnicalSupportText1: this.$t('imTechnicalSupportText1'),
				imTechnicalSupportText2: this.$t('imTechnicalSupportText2'),
				imDisclaimerTitle: this.$t('imDisclaimerTitle'),
				imDisclaimerContentTitle: this.$t('imDisclaimerContentTitle'),
				imDisclaimerContentText1: this.$t('imDisclaimerContentText1'),
				imDisclaimerLinksTitle: this.$t('imDisclaimerLinksTitle'),
				imDisclaimerLinksText1: this.$t('imDisclaimerLinksText1'),
				imDisclaimerCopyrightTitle: this.$t('imDisclaimerCopyrightTitle'),
				imDisclaimerCopyrightText1: this.$t('imDisclaimerCopyrightText1'),
				imDisclaimerMediaTitle: this.$t('imDisclaimerMediaTitle'),
				imDisclaimerMediaText: this.$t('imDisclaimerMediaText'),
			};
		},
	},
	created() {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
		toHome() {
			this.$router.push({
				name: 'Home',
			});
		},
	},
};
</script>

<style scoped>
.im-wrap-site {
	width: 100%;
	padding: 0px;
	margin: 0px;
	overflow-y: hidden;
	/* background-color: var(--main-color-medium); */
	position: relative;
	overflow-x: hidden;
}

.im-wrap-site img {
	width: 300px;
	position: absolute;
	top: 5px;
	left: 5vw;
	cursor: pointer;
}

.im-wrap-content {
	width: 100%;
	padding: 0% 5vw;
	box-sizing: border-box;
}

.im-footer {
	text-align: center;
}

h1 {
	margin: 40px auto 10px auto;
	width: fit-content;
	color: var(--main-color-text-light);
	position: relative;
	font-weight: normal;
	z-index: 0;
	font-size: 50px;
}

h2,
h3 {
	font-weight: normal;
	border-bottom: 1px solid var(--main-color-text-light);
	width: fit-content;
	padding: 10px 15px 5px 0px;
}

h2 {
	color: var(--main-color-highlight);
}

h3 {
	color: var(--secondary-color-highlight);
}

p {
	font-size: 20px;
	color: #ddd;
}

::v-deep a {
	color: var(--secondary-color-highlight);
}

::v-deep a:visited {
	color: #ccc491;
}

@media screen and (max-width: 970px) {
	.im-wrap-site img {
		width: 200px;
		position: static;
		display: block;
		margin: 10px auto;
	}

	.im-wrap-site h1 {
		width: 90vw;
		margin: 10px 5vw 0px 5vw;
		text-align: center;
	}
}

@media (pointer: none), (pointer: coarse) {
	.im-wrap-site h1 {
		font-size: 35px;
	}
}
</style>
